import useAuthStore from '@/stores/useAuthStore';

export const getUserName = (): string => {
    const authStore = useAuthStore();
    const accountInfo = authStore.getAccountInfo();
    const name: string = accountInfo?.name || accountInfo?.username || '';
    const commaIndex = name.indexOf(',');
    return commaIndex > -1 ? name.substring(commaIndex + 1, name.length) : name;
};
